import React, { useMemo } from 'react';

const formatDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const formatLabel = (date) => {
  return date.toLocaleDateString('default', { weekday: 'short', month: 'short', day: 'numeric' });
};

function WeeklySummary({ appointments }) {
  const weekData = useMemo(() => {
    const list = [];
    const today = new Date();
    for (let offset = 0; offset < 7; offset += 1) {
      const date = new Date(today);
      date.setDate(today.getDate() + offset);
      const key = formatDateKey(date);
      const items = appointments[key] || [];
      const totalPayment = items.reduce((sum, item) => {
        const value = parseFloat(item.payment);
        return sum + (Number.isFinite(value) ? value : 0);
      }, 0);
      list.push({
        dateKey: key,
        label: formatLabel(date),
        count: items.length,
        totalPayment,
      });
    }
    return list;
  }, [appointments]);

  const totalWeekAppointments = weekData.reduce((sum, item) => sum + item.count, 0);
  const totalWeekPayment = weekData.reduce((sum, item) => sum + item.totalPayment, 0);

  return (
    <div className="weekly-summary">
      <div className="day-panel-header">
        <h2>Weekly summary</h2>
        <p>See the next seven days at a glance, including appointment counts and income.</p>
      </div>
      <div className="summary-grid">
        {weekData.map((day) => (
          <div key={day.dateKey} className="summary-card">
            <div className="summary-label">{day.label}</div>
            <div className="summary-metric">{day.count} appointment{day.count !== 1 ? 's' : ''}</div>
            <div className="summary-value">${day.totalPayment.toFixed(2)}</div>
          </div>
        ))}
      </div>
      <div className="summary-footer">
        <div>Total appointments: {totalWeekAppointments}</div>
        <div>Total payment: ${totalWeekPayment.toFixed(2)}</div>
      </div>
    </div>
  );
}

export default WeeklySummary;
